<template>
    <v-card>
        <v-img
            v-if="infoPosto.url_imagem_posto"
            :src="infoPosto.url_imagem_posto"
            aspect-ratio="2.75"
        >
        </v-img>
        <v-card-text>
            <v-layout row wrap justify-space-around fill-height>
                <v-flex xs12 class="headline text-xs-center pb-4 pt-4">Detalhes</v-flex>
                <v-flex xs12 sm5>
                    <v-text-field
                        readonly
                        label="Razão Social"
                        v-model="infoPosto.razao_social"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm5>
                    <v-text-field
                        readonly
                        label="Nome Fantasia"
                        v-model="infoPosto.nome_fantasia"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm5>
                    <v-text-field
                        readonly
                        label="CNPJ"
                        v-model="infoPosto.cnpj"
                        mask="##.###.###/####-##"
                        class="text-xs-center"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm5>
                    <v-text-field
                        readonly
                        label="CPF do representante"
                        v-model="infoPosto.representante.cpf"
                        mask="###.###.###-##"
                        class="text-xs-center"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 class="text-xs-center pt-2 pb-2">Endereço</v-flex>
                <v-flex xs5>
                    <v-text-field
                        readonly
                        label="Cidade"
                        v-model="infoPosto.endereco.cidade"
                    ></v-text-field>
                </v-flex>
                <v-flex xs5>
                    <v-text-field
                        readonly
                        label="Bairro"
                        v-model="infoPosto.endereco.bairro"
                    ></v-text-field>
                </v-flex>
                <v-flex xs5>
                    <v-text-field
                        readonly
                        label="Logradouro"
                        v-model="infoPosto.endereco.logradouro"
                    ></v-text-field>
                </v-flex>
                <v-flex xs2>
                    <v-text-field
                        readonly
                        label="Número"
                        v-model="infoPosto.endereco.numero"
                    ></v-text-field>
                </v-flex>
                <v-flex xs3>
                    <v-text-field
                        readonly
                        label="CEP"
                        v-model="infoPosto.endereco.cep"
                        mask="#####-###"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 class="mb-3 mt-3">
          <h2 style="text-align: center" v-if="redesSociais.length > 0">Redes Sociais</h2>
        </v-flex>
        <v-layout wrap justify-space-around v-for="(rede, index) in redesSociais" :key="index">
          <v-flex xs1>
            <v-tooltip bottom v-if="rede.nome">
              <template v-slot:activator="{ on }">
                <img
                  v-on="on"
                  style="width: 70%;"
                  :src="require(`@/assets/icons/${rede.nome}.png`)"
                  class="mr-2"
                />
              </template>
              <span>{{rede.nome}}</span>
            </v-tooltip>
          </v-flex>
          <v-flex xs9 style="font-size: 1em">
            <a :href="rede.link_perfil" target="_blank" style="text-decoration: none; color: gray">
              {{rede.link_perfil}}
            </a>
          </v-flex>
        </v-layout>
            </v-layout>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="$emit('fechar')">Voltar</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>

import { postosDao } from '@/api'

export default {
  props: ['posto'],
  data () {
    return {
      redesSociais: [],
      infoPosto: {
        endereco: {},
        representante: {}
      }
    }
  },
  computed: {
    headers () {
      return this.$store.getters.headers
    }
  },
  mounted () {
    if (this.posto) {
      this.carregarDados()
      this.pegarRedesSociais()
    }
  },
  watch: {
    posto (val) {
      if (val) {
        this.carregarDados()
        this.pegarRedesSociais()
      }
    }
  },
  methods: {
    pegarRedesSociais () {
      const data = { cnpj: this.posto.cnpj, method: 'GET' }
      this.$store.dispatch('redesSociais', data).then(json => {
        this.redesSociais = json
      })
    },
    carregarDados () {
      postosDao.detalhar(this.posto.cnpj, this.headers).then(response => {
        return response.json()
      }).then(json => {
        this.infoPosto = json
      })
    }
  }
}
</script>
